import React from 'react'
import { Outlet } from 'react-router-dom';
import Tasks from './Tasks';
import '../MainBody.css'

function TaskLayout() {
  return (
    <div className='projects_container'>
      <div className='projects_sidebar'>
        <Tasks />
      </div>
      <div className='projects_main'>
        <Outlet />
      </div>
    </div>
  )
}

export default TaskLayout